import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore('credit-processes-simulators', storeModule.createStoreModule('credit-processes-simulators'))
